module.exports = __webpack_public_path__ + "img/Wessels-skrifter_Huset-hvor-Wessel-ble-fodt.393ff768.jpg";